<script>
  import Link from '../../utils/link.html';
  import Form from '../../components/inputs/form';
  import InputText from '../../components/inputs/text';
  import InputDate from '../../components/inputs/date';
  import Loader from '../../components/ui/loader.html';
  import Menu from '../../components/navigation/menu';
  import { onMount, afterUpdate, getContext } from 'svelte';
  import { gql } from 'apollo-boost';

  import PersonInfo from './components/sections/person.info.html';
  import PersonActivity from './components/sections/person.activity.html';
  import PersonHousehold from './components/sections/person.household.html';

  import { PERSON } from '../../graphql/people';

  const client = getContext('apollo');

  export let match = {};
  let loading = true;
  let person;
  let error;

  async function getPerson() {
    try {
      const { data } = await client.query({
        query: PERSON,
        variables: { id: match.params.id }
      });

      person = data.getPerson;
      loading = false;
    } catch (e) {
      loading = false;
      error = e;
    }
  }

  onMount(getPerson);
  afterUpdate(() => {
    if (person && person.id !== match.params.id) {
      getPerson();
    }
  });

  const components = {
    info: PersonInfo,
    household: PersonHousehold,
    activity: PersonActivity
  };

  $: current = components[match.params.section] || components['info'];

  const menu = [
    {
      id: 'info',
      label: 'Person Info',
      link: `/people/view/${match.params.id}`
    },
    {
      id: 'household',
      label: 'Household',
      link: `/people/view/${match.params.id}/household`
    },
    {
      id: 'activity',
      label: 'Activity',
      link: `/people/view/${match.params.id}/activity`
    }
    /*{
      id: 'particpation',
      label: 'Registrations',
      link: `/people/view/${match.params.id}/registrations`
    }*/
  ];
</script>

{#if loading}
<Loader></Loader>
{/if} {#if !loading}
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>{person.firstName} {person.lastName}</h1>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-12">
    <Menu active={match.params.section || 'info'} items={menu} />
  </div>
</div>

<svelte:component
  this="{current}"
  bind:value="{person}"
  id="{match.params.id}"
/>
{/if}
